import { getUserAuditTrail } from '@appt-digital/frontend-api-lib-sheffmed'
import React, { useContext, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import Typography from '../../ui-library/components/Typography'
import { useFormik } from 'formik'
import { contentSchema } from '../../config/validation'

import color from '../../ui-library/styles/color'

import { contentUpdate } from '../../utils/api'

import { AlertContext } from '../../context/AlertContext'
import TextField from '../../ui-library/components/TextField'
import Dropdown from '../../ui-library/components/Dropdown'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '../../ui-library/components/Button'
import Link from '../../ui-library/components/Link'
import { FaUser } from 'react-icons/fa'
import { MdDeleteForever } from 'react-icons/md'
import { ThemeContext } from '../../ui-library/components/ThemeContext'
import DashboardContainer from '../../ui-library/components/DashboardContainer'
import TabHeader from '../../ui-library/components/TabHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import toCapitalised from '../../utils/capitaliseString'

import { uploadFile } from '../../utils/api'

import { MDXEditor, UndoRedo, ListsToggle, BoldItalicUnderlineToggles, InsertImage, toolbarPlugin, listsPlugin, quotePlugin, imagePlugin } from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import './override.css'
import { Box } from '@mui/material'


function EditContent() {
  const [loading, setLoading] = useState(false)
  const { setAlert } = useContext(AlertContext)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmReset, setConfirmReset] = useState(false)
  const [audit, setAudit] = useState([])
  const { theme } = useContext(ThemeContext)
  const { state } = useLocation()
  const navigate = useNavigate()
  const initialEdit = {
    title: state?.content?.title || '',
    slug: state?.content?.slug || '',
    // markdown: state?.content?.markdown || '',
    moreLink: state?.content?.moreLink || '',
    moreText: state?.content?.moreText || '',
    // paymentByInvoice: !!state?.content?.paymentByInvoice,
    // priceTier: state?.content?.priceTier || '',
    // shippingTier: state?.content?.shippingTier || ''
  }
  const [markdown, setMarkdown] = useState(state?.content?.markdown || '')


  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialEdit,
      validationSchema: contentSchema,
      onSubmit: async () => await handleEdit(),
    })
  const handleEdit = async () => {
    let response = await contentUpdate(
      state?.content?.id,
      {
        ...values,
        markdown: markdown,
      }
    )
    // setAlert,
    setLoading(false)
    navigate('/dashboard/content')
  }

  async function imageUploadHandler(file) {
    const formData = new FormData()
    formData.append('file', file)
    return new Promise((resolve, reject) => {
      
        // get the base64 data of the file
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = async () => {

          try {
            const data = reader.result.split(',')[1] // get the base64 data without the prefix
            let results = await uploadFile(file.name, file.type, data, true)
            resolve(results?.url)
          } catch (error) {
            reject(error)
          }
          
        }
        
  
    })
  }


  return (
    <>
      <DashboardContainer>
        <TabHeader
          title={'Edit Content'}
          username={
            state?.user?.firstname !== null &&
            state?.user?.firstname !== undefined &&
            state?.user?.lastname !== null &&
            state?.user?.lastname !== undefined &&
            `${toCapitalised(state?.user?.firstname)} ${toCapitalised(
              state?.user?.lastname
            )}`
          }
        >
          <Paper style={theme?.dashboard?.container}>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
              <div>
                <Link
                  type="submit"
                  onClick={() => {
                    navigate('/dashboard/content')
                  }}
                >
                  {`< Back`}
                </Link>
                <Typography source={'h1'} style={{ marginTop: 20 }}>Edit Content</Typography>

                <form onSubmit={handleSubmit}>

                    {/* 

                      Title
                      Summary
                      Description <TEXTAREA>
                      Photo
                      Base Price, Tier 1, Tier 2, Tier 3
                    
                    */}

                  <div
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Title</Typography>
                    <TextField
                      type="title"
                      name="title"
                      placeholder="Title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'title'}
                      errors={errors}
                      touched={touched}
                    />
                  </div>

                  <div
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <Typography source={'h4'} style={{ marginTop: 10 }}>Content</Typography>
                    {/* <TextField
                      type="markdown"
                      name="markdown"
                      placeholder="Content"
                      value={values.markdown}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorType={'markdown'}
                      errors={errors}
                      touched={touched}
                    /> */}

                    <Box style={{ 
                      backgroundColor: color.white,
                      borderRadius: 10,
                      // height: 45,
                      width: '100%',
                      container: {
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        marginBottom: 10,
                      },
                      border: `1px solid ${color.black}` 
                    }}>
                      <MDXEditor 
                        markdown={markdown}
                        onChange={setMarkdown} 
                        
                        plugins={[
                          toolbarPlugin({
                            toolbarClassName: 'my-classname',
                            toolbarContents: () => (
                              <>
                                <UndoRedo />
                                <BoldItalicUnderlineToggles />
                                <InsertImage />
                                <ListsToggle />
                                <UndoRedo />
                              </>
                            )
                          }),
                          imagePlugin({ imageUploadHandler, disableImageResize: true, disableImageSettingsButton: true }),
                          listsPlugin(), 
                          quotePlugin()
                        ]}
                      />
                    </Box>

                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                    <Button type="submit">Save</Button>

                  </div>
                </form>
              </div>
           
            </div>
          </Paper>
        </TabHeader>
      </DashboardContainer>
    </>
  )
}

export default EditContent
